import React from 'react';

const Checkmark = (props) => (
	<div className="radio-group">
		<label className="checkmark-container">
			<input {...props} type="checkbox" />
			<span className="custom-checkmark"></span>
		</label>
		<span>{props.text || (props.name ? props.name : "")}</span>
	</div>
)

export default Checkmark



// WEBPACK FOOTER //
// ./src/components/form/Checkmark.js